const TRANS_copyRoutes = (function () {
  let copyRoutesPopup;
  let copyRoutesParams;
  let locationDropdown, routeNameDropdown, driverDropdown, vehicleDropdown;
  let copyFromDateInputs, copyToDateInputs;
  let fromDatesError, saveBtn;

  function parseDate(value) {
    if (!value) return '';
    const date = new Date(`${value} 00:00:00`);
    return date instanceof Date && !isNaN(date) ? date : '';
  }

  function formatDate(date) {
    return dates.formatISO(date).slice(0, 10);
  }

  function getDaySpan() {
    if (!copyRoutesParams.copyFrom.start || !copyRoutesParams.copyFrom.end) return null;
    return dates.differenceInDays(copyRoutesParams.copyFrom.end, copyRoutesParams.copyFrom.start);
  }

  function buildRetrieveData() {
    return {
      token: $.session.Token,
      locationId: copyRoutesParams.locationId || '',
      routeName: copyRoutesParams.routeName || '',
      driverId: copyRoutesParams.driverId || '',
      vehicleInformationId: copyRoutesParams.vehicleInformationId || '',
      copyFromFromDate: copyRoutesParams.copyFrom.start ? formatDate(copyRoutesParams.copyFrom.start) : '',
      copyFromToDate: copyRoutesParams.copyFrom.end ? formatDate(copyRoutesParams.copyFrom.end) : '',
      copyToFromDate: copyRoutesParams.copyTo.start ? formatDate(copyRoutesParams.copyTo.start) : '',
      copyToToDate: copyRoutesParams.copyTo.end ? formatDate(copyRoutesParams.copyTo.end) : '',
    };
  }

  function optionText(record, keys) {
    for (let i = 0; i < keys.length; i++) {
      if (record[keys[i]] !== undefined && record[keys[i]] !== null) return record[keys[i]];
    }
    return '';
  }

  function getDriverName(record) {
    return optionText(record, ['driverName', 'DriverName', 'text']);
  }

  function mapDropdownRecord(record, dropdownType) {
    switch (dropdownType) {
      case 'location':
        return {
          value: optionText(record, ['value', 'id', 'locationId', 'location_id', 'ID']),
          text: optionText(record, ['text', 'description', 'locationDescription', 'Name']),
        };
      case 'route':
        return {
          value: optionText(record, ['value', 'tripName', 'trip_name']),
          text: optionText(record, ['text', 'tripName', 'trip_name']),
        };
      case 'driver':
        return {
          value: optionText(record, ['value', 'driverId', 'driver_id', 'personId', 'person_id', 'Person_ID']),
          text: getDriverName(record),
        };
      case 'vehicle':
        return {
          value: optionText(record, [
            'value',
            'vehicleInformationId',
            'vehicle_information_id',
            'vehicleInfoId',
          ]),
          text: optionText(record, ['text', 'vehicleNumber', 'vehicle_number']),
        };
      default:
        return {
          value: optionText(record, ['value', 'id']),
          text: optionText(record, ['text', 'description']),
        };
    }
  }

  function populateCopyDropdown(dropdownEle, data, selectedValue, dropdownType) {
    const dropdownData = data.map(record => mapDropdownRecord(record, dropdownType));
    const allValue = dropdownType === 'route' ? '%' : '-1';

    dropdownData.unshift({ value: allValue, text: 'ALL' });
    dropdownData.unshift({ value: '', text: '' });
    dropdown.populate(dropdownEle, dropdownData, selectedValue || '');
  }

  function getFieldElement(target) {
    if (!target || !target.closest) return null;
    return target.closest(
      '#copyRoutesLocationDropdown, #copyRoutesRouteNameDropdown, #copyRoutesDriverDropdown, #copyRoutesVehicleDropdown, #copyRoutesFromDateStart, #copyRoutesFromDateEnd, #copyRoutesToDateStart, #copyRoutesToDateEnd',
    );
  }

  function getFieldValue(fieldEle) {
    if (!fieldEle) return '';
    if ('value' in fieldEle) return fieldEle.value;

    const control = fieldEle.querySelector('select, input, textarea');
    if (control) return control.value;

    return fieldEle.getAttribute('data-value') || '';
  }

  function clearDisabledDropdown(dropdownEle) {
    dropdown.populate(dropdownEle, [{ value: '', text: '' }], '');
    const control = dropdownEle.querySelector('select, input');
    if (control) control.value = '';
    input.disableInputField(dropdownEle);
    dropdownEle.classList.add('error');
  }

  async function populateLocationDropdown() {
    const result = await TRANS_manageRoutesAjax.getCopyRoutesLocations({
      token: $.session.Token,
    });
    populateCopyDropdown(
      locationDropdown,
      result.getCopyRoutesLocationsResult || [],
      copyRoutesParams.locationId,
      'location',
    );
  }

  async function populateRouteNameDropdown() {
    if (!copyRoutesParams.locationId) {
      clearDisabledDropdown(routeNameDropdown);
      return;
    }

    const result = await TRANS_manageRoutesAjax.getCopyRoutesRouteNames(buildRetrieveData());
    populateCopyDropdown(
      routeNameDropdown,
      result.getCopyRoutesRouteNamesResult || [],
      copyRoutesParams.routeName,
      'route',
    );
    input.enableInputField(routeNameDropdown);
    routeNameDropdown.classList.toggle('error', !copyRoutesParams.routeName);
  }

  async function populateDriverDropdown() {
    if (!copyRoutesParams.routeName) {
      clearDisabledDropdown(driverDropdown);
      return;
    }

    const result = await TRANS_manageRoutesAjax.getCopyRoutesDrivers(buildRetrieveData());
    populateCopyDropdown(
      driverDropdown,
      result.getCopyRoutesDriversResult || [],
      copyRoutesParams.driverId,
      'driver',
    );
    input.enableInputField(driverDropdown);
    driverDropdown.classList.toggle('error', !copyRoutesParams.driverId);
  }

  async function populateVehicleDropdown() {
    if (!copyRoutesParams.driverId) {
      clearDisabledDropdown(vehicleDropdown);
      return;
    }

    const result = await TRANS_manageRoutesAjax.getCopyRoutesVehicles(buildRetrieveData());
    populateCopyDropdown(
      vehicleDropdown,
      result.getCopyRoutesVehiclesResult || [],
      copyRoutesParams.vehicleInformationId,
      'vehicle',
    );
    input.enableInputField(vehicleDropdown);
    vehicleDropdown.classList.toggle('error', !copyRoutesParams.vehicleInformationId);
  }

  function resetRouteSelection() {
    copyRoutesParams.routeName = '';
    copyRoutesParams.driverId = '';
    copyRoutesParams.vehicleInformationId = '';
    routeNameDropdown.classList.add('error');
    driverDropdown.classList.add('error');
    vehicleDropdown.classList.add('error');
  }

  function resetDriverSelection() {
    copyRoutesParams.driverId = '';
    copyRoutesParams.vehicleInformationId = '';
    driverDropdown.classList.add('error');
    vehicleDropdown.classList.add('error');
  }

  function resetVehicleSelection() {
    copyRoutesParams.vehicleInformationId = '';
    vehicleDropdown.classList.add('error');
  }

  function copyFromRangeIsValid() {
    if (!copyRoutesParams.copyFrom.start || !copyRoutesParams.copyFrom.end) return false;
    return (
      dates.isBefore(copyRoutesParams.copyFrom.start, copyRoutesParams.copyFrom.end) ||
      dates.isEqual(copyRoutesParams.copyFrom.start, copyRoutesParams.copyFrom.end)
    );
  }

  function copyToRangeIsValid() {
    if (!copyFromRangeIsValid() || !copyRoutesParams.copyTo.start || !copyRoutesParams.copyTo.end) {
      return false;
    }

    return (
      dates.differenceInDays(copyRoutesParams.copyTo.end, copyRoutesParams.copyTo.start) ===
      getDaySpan()
    );
  }

  function validateCopyToDates() {
    const copyFromIsValid = copyFromRangeIsValid();
    const copyToIsValid = copyToRangeIsValid();

    copyToDateInputs.start.classList.toggle(
      'error',
      copyFromIsValid && (!copyRoutesParams.copyTo.start || !copyToIsValid),
    );
    copyToDateInputs.end.classList.toggle(
      'error',
      copyFromIsValid && (!copyRoutesParams.copyTo.end || !copyToIsValid),
    );
  }

  function handleCopyFromDateChange() {
    const validRange = copyFromRangeIsValid();
    const hasBothCopyFromDates = copyRoutesParams.copyFrom.start && copyRoutesParams.copyFrom.end;

    copyFromDateInputs.start.classList.toggle('error', !copyRoutesParams.copyFrom.start);
    copyFromDateInputs.end.classList.toggle(
      'error',
      !copyRoutesParams.copyFrom.end || (hasBothCopyFromDates && !validRange),
    );
    fromDatesError.innerHTML =
      hasBothCopyFromDates && !validRange ? `${icons.error} From date can't be after to date.` : '';

    if (!validRange) {
      copyRoutesParams.copyTo.start = '';
      copyRoutesParams.copyTo.end = '';
      input.setValue(copyToDateInputs.start, '');
      input.setValue(copyToDateInputs.end, '');
      input.disableInputField(copyToDateInputs.start);
      input.disableInputField(copyToDateInputs.end);
      copyToDateInputs.start.classList.add('error');
      copyToDateInputs.end.classList.add('error');
      return;
    }

    input.enableInputField(copyToDateInputs.start);
    input.enableInputField(copyToDateInputs.end);

    if (copyRoutesParams.copyTo.start) {
      setCopyToEndFromStart();
    } else if (copyRoutesParams.copyTo.end) {
      setCopyToStartFromEnd();
    }

    validateCopyToDates();
  }

  function setCopyToEndFromStart() {
    const daySpan = getDaySpan();
    if (daySpan === null || !copyRoutesParams.copyTo.start) return;
    copyRoutesParams.copyTo.end = dates.addDays(copyRoutesParams.copyTo.start, daySpan);
    input.setValue(copyToDateInputs.end, formatDate(copyRoutesParams.copyTo.end));
    copyToDateInputs.end.classList.remove('error');
  }

  function setCopyToStartFromEnd() {
    const daySpan = getDaySpan();
    if (daySpan === null || !copyRoutesParams.copyTo.end) return;
    copyRoutesParams.copyTo.start = dates.addDays(copyRoutesParams.copyTo.end, daySpan * -1);
    input.setValue(copyToDateInputs.start, formatDate(copyRoutesParams.copyTo.start));
    copyToDateInputs.start.classList.remove('error');
  }

  function checkRequiredFields() {
    locationDropdown.classList.toggle('error', !copyRoutesParams.locationId);
    routeNameDropdown.classList.toggle('error', !copyRoutesParams.routeName);
    driverDropdown.classList.toggle('error', !copyRoutesParams.driverId);
    vehicleDropdown.classList.toggle('error', !copyRoutesParams.vehicleInformationId);
    validateCopyToDates();

    const isValid =
      copyRoutesParams.locationId &&
      copyRoutesParams.routeName &&
      copyRoutesParams.driverId &&
      copyRoutesParams.vehicleInformationId &&
      copyFromRangeIsValid() &&
      copyToRangeIsValid();

    saveBtn.classList.toggle('disabled', !isValid);
  }

  function showCopyRoutesMessagePopup(messageText) {
    const popup = POPUP.build({
      hideX: true,
    });
    const message = document.createElement('p');
    message.classList.add('message');
    message.textContent = messageText;
    const okBtn = button.build({
      text: 'OK',
      style: 'secondary',
      type: 'contained',
      callback: () => POPUP.hide(popup),
    });
    popup.appendChild(message);
    popup.appendChild(okBtn);
    POPUP.show(popup);
  }

  function serverValueIsTrue(value) {
    if (value === true) return true;
    const normalizedValue = String(value || '').trim().toLowerCase();
    return normalizedValue === 'true' || normalizedValue === '1' || normalizedValue === 'yes';
  }

  function getCopyRoutesFailureMessages(saveResult) {
    const failureMessages = [];
    const terminatedCount = Number(saveResult.terminatedCount || 0);

    if (serverValueIsTrue(saveResult.personsTerminated)) {
      failureMessages.push(
        'At least one route could not be created, because the driver has been terminated.',
      );
    }

    if (serverValueIsTrue(saveResult.driversTerminated)) {
      failureMessages.push(
        'At least one route could not be created, because the driver is not eligible.',
      );
    }

    if (serverValueIsTrue(saveResult.vehicleTerminated)) {
      failureMessages.push(
        'At least one route could not be created, because the associated vehicle is inactive.',
      );
    }

    if (serverValueIsTrue(saveResult.consumerTerminated)) {
      failureMessages.push(
        'At least one individual could not be added to a route because he/she is inactive.',
      );
    }

    if (failureMessages.length > 0) return failureMessages;

    const successValue = String(saveResult.success || '').trim().toLowerCase();
    const copyFailed =
      saveResult.success === false || successValue === 'false' || successValue === '0' || terminatedCount > 0;

    if (copyFailed) {
      return [saveResult.messageResult || 'At least one route could not be created.'];
    }

    return [];
  }

  async function handleFormChange({ target }) {
    const fieldEle = getFieldElement(target);
    if (!fieldEle) return;

    const fieldValue = getFieldValue(fieldEle);

    switch (fieldEle.id) {
      case 'copyRoutesLocationDropdown':
        copyRoutesParams.locationId = fieldValue;
        resetRouteSelection();
        await populateRouteNameDropdown();
        await populateDriverDropdown();
        await populateVehicleDropdown();
        break;
      case 'copyRoutesRouteNameDropdown':
        copyRoutesParams.routeName = fieldValue;
        resetDriverSelection();
        await populateDriverDropdown();
        await populateVehicleDropdown();
        break;
      case 'copyRoutesDriverDropdown':
        copyRoutesParams.driverId = fieldValue;
        resetVehicleSelection();
        await populateVehicleDropdown();
        break;
      case 'copyRoutesVehicleDropdown':
        copyRoutesParams.vehicleInformationId = fieldValue;
        break;
      case 'copyRoutesToDateStart':
        copyRoutesParams.copyTo.start = parseDate(fieldValue);
        copyToDateInputs.start.classList.toggle('error', !copyRoutesParams.copyTo.start);
        setCopyToEndFromStart();
        break;
      case 'copyRoutesToDateEnd':
        copyRoutesParams.copyTo.end = parseDate(fieldValue);
        copyToDateInputs.end.classList.toggle('error', !copyRoutesParams.copyTo.end);
        setCopyToStartFromEnd();
        break;
      default:
        break;
    }

    checkRequiredFields();
  }

  async function handleFormChangeFocus({ target }) {
    const fieldEle = getFieldElement(target);
    if (!fieldEle) return;

    const fieldValue = getFieldValue(fieldEle);

    switch (fieldEle.id) {
      case 'copyRoutesFromDateStart':
        copyRoutesParams.copyFrom.start = parseDate(fieldValue);
        handleCopyFromDateChange();
        break;
      case 'copyRoutesFromDateEnd':
        copyRoutesParams.copyFrom.end = parseDate(fieldValue);
        handleCopyFromDateChange();
        break;
      case 'copyRoutesToDateStart':
        copyRoutesParams.copyTo.start = parseDate(fieldValue);
        copyToDateInputs.start.classList.toggle('error', !copyRoutesParams.copyTo.start);
        setCopyToEndFromStart();
        break;
      case 'copyRoutesToDateEnd':
        copyRoutesParams.copyTo.end = parseDate(fieldValue);
        copyToDateInputs.end.classList.toggle('error', !copyRoutesParams.copyTo.end);
        setCopyToStartFromEnd();
        break;
      default:
        break;
    }

    checkRequiredFields();
  }

  async function handleFormSubmit() {
    if (saveBtn.classList.contains('disabled')) return;

    POPUP.hide(copyRoutesPopup);
    pendingSave.show('Copying Routes...');

    try {
      const result = await TRANS_manageRoutesAjax.copyRoutes(buildRetrieveData());
      const copyRoutesResult = result.copyRoutesResult || result;
      const saveResult = Array.isArray(copyRoutesResult)
        ? copyRoutesResult[0] || {}
        : copyRoutesResult || {};
      const failureMessages = getCopyRoutesFailureMessages(saveResult);

      if (failureMessages.length > 0) {
        pendingSave.hide();
        showCopyRoutesMessagePopup(failureMessages.join(' '));
        return;
      }

      pendingSave.fulfill('Routes have been copied');
      setTimeout(() => {
        successfulSave.hide();
        TRANS_manageRoutes.refresh();
      }, 3000);
    } catch (error) {
      pendingSave.reject('Failed to copy routes. Please try again.');
      console.error(error);
      setTimeout(() => failSave.hide(), 3000);
    }
  }

  function buildDateGroup(className, legendText, startInput, endInput, errorEle) {
    const wrap = document.createElement('fieldset');
    const legend = document.createElement('legend');
    legend.textContent = legendText;
    wrap.classList.add('datesWrap', className);
    errorEle.classList.add('datesError');
    wrap.appendChild(legend);
    wrap.appendChild(startInput);
    wrap.appendChild(endInput);
    wrap.appendChild(errorEle);
    return wrap;
  }

  async function showPopup() {
    copyRoutesParams = {
      locationId: '',
      routeName: '',
      driverId: '',
      vehicleInformationId: '',
      copyFrom: {},
      copyTo: {},
    };

    copyRoutesPopup = POPUP.build({
      id: 'copyRoutesPopup',
      header: 'Copy Routes',
      classNames: 'copyRoutesPopup',
    });

    locationDropdown = dropdown.build({
      dropdownId: 'copyRoutesLocationDropdown',
      label: 'Location',
      style: 'secondary',
    });
    routeNameDropdown = dropdown.build({
      dropdownId: 'copyRoutesRouteNameDropdown',
      label: 'Route Name',
      style: 'secondary',
    });
    driverDropdown = dropdown.build({
      dropdownId: 'copyRoutesDriverDropdown',
      label: 'Driver',
      style: 'secondary',
    });
    vehicleDropdown = dropdown.build({
      dropdownId: 'copyRoutesVehicleDropdown',
      label: 'Vehicle',
      style: 'secondary',
    });

    copyFromDateInputs = {
      start: input.build({
        id: 'copyRoutesFromDateStart',
        type: 'date',
        label: 'From Date',
        style: 'secondary',
      }),
      end: input.build({
        id: 'copyRoutesFromDateEnd',
        type: 'date',
        label: 'To Date',
        style: 'secondary',
      }),
    };
    copyToDateInputs = {
      start: input.build({
        id: 'copyRoutesToDateStart',
        type: 'date',
        label: 'From Date',
        style: 'secondary',
      }),
      end: input.build({
        id: 'copyRoutesToDateEnd',
        type: 'date',
        label: 'To Date',
        style: 'secondary',
      }),
    };

    fromDatesError = document.createElement('p');
    const toDatesError = document.createElement('p');

    saveBtn = button.build({
      text: 'SAVE',
      style: 'secondary',
      type: 'contained',
      icon: 'save',
      classNames: 'disabled',
      callback: handleFormSubmit,
    });
    const cancelBtn = button.build({
      text: 'CANCEL',
      style: 'secondary',
      type: 'outlined',
      icon: 'close',
      callback: () => POPUP.hide(copyRoutesPopup),
    });

    input.disableInputField(routeNameDropdown);
    input.disableInputField(driverDropdown);
    input.disableInputField(vehicleDropdown);
    input.disableInputField(copyToDateInputs.start);
    input.disableInputField(copyToDateInputs.end);

    locationDropdown.classList.add('error');
    routeNameDropdown.classList.add('error');
    driverDropdown.classList.add('error');
    vehicleDropdown.classList.add('error');
    copyFromDateInputs.start.classList.add('error');
    copyFromDateInputs.end.classList.add('error');
    copyToDateInputs.start.classList.add('error');
    copyToDateInputs.end.classList.add('error');

    const fromDatesWrap = buildDateGroup(
      'copyRoutesFromDates',
      'Copy From:',
      copyFromDateInputs.start,
      copyFromDateInputs.end,
      fromDatesError,
    );
    const toDatesWrap = buildDateGroup(
      'copyRoutesToDates',
      'Copy To:',
      copyToDateInputs.start,
      copyToDateInputs.end,
      toDatesError,
    );

    const buttonWrap = document.createElement('div');
    buttonWrap.classList.add('btnWrap');
    buttonWrap.appendChild(saveBtn);
    buttonWrap.appendChild(cancelBtn);

    copyRoutesPopup.appendChild(fromDatesWrap);
    copyRoutesPopup.appendChild(toDatesWrap);
    copyRoutesPopup.appendChild(locationDropdown);
    copyRoutesPopup.appendChild(routeNameDropdown);
    copyRoutesPopup.appendChild(driverDropdown);
    copyRoutesPopup.appendChild(vehicleDropdown);
    copyRoutesPopup.appendChild(buttonWrap);

    copyRoutesPopup.addEventListener('change', handleFormChange);
    copyRoutesPopup.addEventListener('focusout', handleFormChangeFocus);
    POPUP.show(copyRoutesPopup);

    await populateLocationDropdown();
    await populateRouteNameDropdown();
    await populateDriverDropdown();
    await populateVehicleDropdown();
  }

  return {
    showPopup,
  };
})();
